import API from '.';
//business_line_code
//business_line_name

export default class BusinessLine {
  /**
   * The Country dimension table for UDM
   * @param {number} business_line_code Id of the country.
   * @param {string} business_line_name Name of the country.
   * @param {string} business_division_code Code of the country.
   * @param {string} business_line_acronym Code of the country.
   * @param {string} businessLineReportUnit Code of the country.
   */
  constructor({ business_line_code, business_line_name, business_division_code, business_line_acronym, businessLineReportUnit }) {
    this.business_line_code = business_line_code;
    this.business_line_name = business_line_name;
    this.business_division_code = business_division_code;
    this.business_line_acronym = business_line_acronym;
    this.businessLineReportUnit = businessLineReportUnit;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/businessLine');
    return data.map((d) => new BusinessLine(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`/businessLine/${id}`);
    return new BusinessLine(data);
  }

  static async getByReportingUnit(companyCode) {
    const api = await API();
    const { data } = await api.get(`/businessLineByReportingUnit/${companyCode}`);
    return data.map((d) => new BusinessLine(d));
  }
}





